import { createContext, useContext, useState } from "react";
import { ConciergeEstimator } from "@/components/ConciergeEstimator";

const ConciergeContext = createContext(null);

export function ConciergeProvider({ children }) {
  const [open, setOpen] = useState(false);
  return (
    <ConciergeContext.Provider value={{ open, openConcierge: () => setOpen(true), close: () => setOpen(false) }}>
      {children}
      <ConciergeEstimator open={open} onClose={() => setOpen(false)} />
    </ConciergeContext.Provider>
  );
}

export const useConcierge = () => useContext(ConciergeContext);
